import { render, staticRenderFns } from "./TaskUpdateForm.vue?vue&type=template&id=faa8f652&scoped=true&"
import script from "./TaskUpdateForm.vue?vue&type=script&lang=js&"
export * from "./TaskUpdateForm.vue?vue&type=script&lang=js&"
import style0 from "./TaskUpdateForm.vue?vue&type=style&index=0&id=faa8f652&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faa8f652",
  null
  
)

/* custom blocks */
import block0 from "./TaskUpdateForm.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports